'use client';
import React from 'react';
import { CategoryDescription as SharedCategoryDescription } from '@launchstore/shared-puck';
import type { CategoryDescriptionProps } from '@launchstore/shared-puck';
import { useCategory } from '@lib/hooks/useCategory';

const SharedCategoryDescriptionRender = (SharedCategoryDescription as any).render;

const CategoryDescriptionImpl: React.FC<CategoryDescriptionProps> = (props) => {
  const { category } = useCategory() as any;
  return <SharedCategoryDescriptionRender {...(props as any)} category={category} />;
};

export const CategoryDescription: any = { ...SharedCategoryDescription, render: (props: any) => <CategoryDescriptionImpl {...props} /> };
export default CategoryDescription;
